import { useRequest } from 'ahooks'
import { Button } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { getPointPermission } from '@/components'
import { JQLTable, JiraResp } from '@/components/jql/jql-table.component'
import { JiraColumnProps } from '@/modules/project/project-detail/project-jql/project-jql-table-config.component'
import { PAGE_RESOURCE_POINTS_ENUM, ResourceType } from '@/schemas'

import { Customer } from '../../customer.schema'
import { CustomerJQLEdit } from './customer-jql-edit.component'
import { CustomerJqlTableConfig } from './customer-jql-table-config.component'

interface CustomerJQLProps {
  customer: Customer
}

export const CustomerJQLContainer: React.FC<CustomerJQLProps> = ({ customer }) => {
  const { t } = useTranslation()
  const { selfId, jql: initialJql } = customer
  const { editable: editableConfig } = getPointPermission(
    PAGE_RESOURCE_POINTS_ENUM.需求与问题_配置,
    customer.permissions
  )
  const { editable: editableContent } = getPointPermission(
    PAGE_RESOURCE_POINTS_ENUM.需求与问题_内容,
    customer.permissions
  )
  const [editVisible, setEditVisible] = React.useState(false)
  const [configVisible, setConfigVisible] = React.useState(false)
  const [jql, setJql] = React.useState(initialJql)

  const {
    data: jiraTableData,
    run: jiraTableRefresh,
    loading: jiraTableLoading,
  } = useRequest<JiraColumnProps[]>(() => ({
    url: '/api/project/getJiraTableConfig',
    method: 'get',
    params: {
      selfId,
      type: ResourceType.CUSTOMER,
    },
  }))

  const { data, loading, run } = useRequest<JiraResp>(
    {
      url: '/api/project/getJiraAndUpdate',
      params: {
        selfId: customer.selfId,
        type: ResourceType.CUSTOMER,
        jql,
      },
    },
    {
      manual: true,
      refreshOnWindowFocus: false,
      debounceInterval: 800,
    }
  )

  // ready和refreshDeps配合时只会在第一次生效
  // https://github.com/alibaba/hooks/issues/468
  React.useEffect(() => {
    if (jql) {
      run()
    }
  }, [jql])

  const issues = data?.issues || []
  const hasBugField = issues.some((issue) => issue.bugResolved !== 'N/A')
  const hasReleaseStatusField = issues.some((issue) => issue.isReleaseType)

  const dropdown = (
    <div className='flex mb-4 justify-between'>
      <Button type='primary' disabled={!editableConfig} onClick={() => setConfigVisible(true)}>
        {t('list config')}
      </Button>
      <Button type='primary' disabled={!editableContent} onClick={() => setEditVisible(true)}>
        {t('associate jira')}
      </Button>
      {/* </Dropdown> */}
    </div>
  )

  const table = jql && (
    <JQLTable
      columns={jiraTableData || []}
      issues={issues}
      loading={loading || jiraTableLoading}
      entity={{ name: customer.name, type: ResourceType.CUSTOMER }}
    />
  )

  return (
    <div>
      {dropdown}
      {table}
      <CustomerJQLEdit
        columns={jiraTableData || []}
        selfId={selfId}
        jql={jql}
        onSuccess={setJql}
        visible={editVisible}
        setVisible={setEditVisible}
        customer={customer}
      />
      <CustomerJqlTableConfig
        columns={jiraTableData || []}
        selfId={selfId}
        visible={configVisible}
        setVisible={setConfigVisible}
        refresh={jiraTableRefresh}
        hasBugField={hasBugField}
        hasReleaseStatusField={hasReleaseStatusField}
      />
    </div>
  )
}
